"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MagazinePDF = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const MagazinePDF = props => {
  const {
    magazineUrl
  } = props;
  const fullUrl = window.location.origin + magazineUrl + "#navpanes=0&scrollbar=0&zoom=100";
  (0, _react.useEffect)(() => {
    if (window.innerWidth <= 850) {
      window.location.href = window.location.origin + magazineUrl;
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-magazine-container con-text con-text__large-medium"
  }, /*#__PURE__*/_react.default.createElement("iframe", {
    className: "pdf-viewer",
    src: fullUrl
  }));
};
exports.MagazinePDF = MagazinePDF;
MagazinePDF.propTypes = {
  magazineUrl: _propTypes.default.string
};